import React from "react";
import {
  Button,
  Divider,
  InfoTimeCardAdv,
  NewTable,
  PageHeader,
  PageTitle,
  useFormHandler,
} from "../../../../../../components";
import { mapTableRows } from "../../../../../../utils";

const OrganizationDocuments = () => {
  const tableData = [
    {
      name: "",
      documentType: "",
      created: "",
    },
  ];
  const columns = [
    {
      key: "name",
      label: "Name",
    },

    {
      key: "documentType ",
      label: "Document Type ",
    },
    {
      key: "created",
      label: "Created",
    },
  ];

  const mappedRows = mapTableRows(tableData, columns);
  return (
    <div>
      <div className="flex gap-8 mb-6 ">
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Offboarding ID"
            value="EX2022-20"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Date of Release"
            value="11/11/2021"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Notice Due"
            value="10/11/2021"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Exit Type"
            value="Resignation"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
        <div className="flex-1">
          <InfoTimeCardAdv
            title="Status"
            value="Released"
            prefix=""
            suffix=""
            align={"center"}
            color="info"
            size="xs"
          />
        </div>
      </div>

      <PageHeader
        Section={
          <div className="flex">
            <PageTitle
              title={"ORGANIZATION DOUCMENTS"}
              icon={"cases"}
              tag="p"
            />
          </div>
        }
        RightSection={
          <>
            <Button title="Send Notification" size="sm" />
          </>
        }
      />

      <Divider className="mt-1" />
      <div className="mt-6">
        <NewTable
          rows={mappedRows}
          columns={columns}
          hideToolBar
          showCheckbox
        />
      </div>
      <p className="body-two mt-24">
        Last updated on 01/12/2022 at 17:41:13 by Richa Sarkar.{" "}
        <span className="text-info cursor-pointer">View All Activities</span>
      </p>
    </div>
  );
};

export default OrganizationDocuments;
